import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { message, Switch } from 'antd'
import { SActionBtn, SLowcodeList, SMessage, STableActions } from 'shj-components'
import { apiData2Table } from '@/utils/data'
import config from './config'
import AddOrRenameModal from './modalOrDrawers/addOrRenameModal'
import { deleteSignTemplate, getSignTemplateList, updateSignTemplate } from '@/services/goods'
import KeepAlive from 'react-activation'

const SignTemplate = () => {
  const listRef = useRef<any>()
  const navigate = useNavigate()
  const [isAdd, setIsAdd] = useState(true)
  const [clickInfo, setClickInfo] = useState({})
  const [addOrRenameModal, setAddOrRenameModal] = useState(false)

  // 新增模版
  const addTemplate = () => {
    setIsAdd(true)
    setClickInfo({})
    setAddOrRenameModal(true)
  }

  // 获取列表数据
  const fetchList = (params: any) => {
    return new Promise((resolve, reject) => {
      try {
        getSignTemplateList({
          params: {
            pageId: params.current || 1,
            pageSize: params.pageSize || 10,
          },
          data: {
            nameLike: params.query.name,
            searchFlag: true,
          },
        }).then((res: any) => {
          resolve(apiData2Table(res))
        })
      } catch {
        reject({ success: false })
      }
    })
  }

  // 开关渲染
  const switchRender = (isChecked: boolean, record: Record<string, any>) => {
    return (
      <Switch
        checked={isChecked}
        checkedChildren="启用"
        unCheckedChildren="禁用"
        onClick={checked => onChangeStatus(checked, record.id, record.name)}
      />
    )
  }

  // 启用/禁用状态改变
  const onChangeStatus = (checked: boolean, id: string, name: string) => {
    SMessage.confirm({
      title: `${checked ? '打开' : '关闭'}开关，将${checked ? '启用' : '禁用'}模板，是否继续？`,
      okText: '继续',
      content: null,
      onOk: () => {
        updateSignTemplate({
          id,
          name,
          enable: checked,
        }).then(() => {
          message.success('操作成功')
          listRef.current?.reload()
        })
        return Promise.resolve()
      },
    })
  }

  // 删除模版
  const deleteTemplate = (id: string) => {
    SMessage.confirm({
      title: '提示',
      content: '确定删除该模板吗？',
      onOk: () => {
        deleteSignTemplate(id).then(() => {
          message.success('操作成功')
          listRef.current?.reload()
        })
      },
    })
  }
  // 操作按钮渲染
  const actionTool = (_text: any, record: any) => {
    return (
      <STableActions>
        <SActionBtn
          onClick={() => {
            setIsAdd(false)
            setClickInfo(record)
            setAddOrRenameModal(true)
          }}
        >
          重命名
        </SActionBtn>
        <SActionBtn
          onClick={() => {
            navigate(`/config/signTemplate/templateDetail/${record.id}/${record.name}`)
          }}
        >
          模板配置
        </SActionBtn>
        {!record?.enable && (
          <SActionBtn danger onClick={() => deleteTemplate(record.id)}>
            删除
          </SActionBtn>
        )}
      </STableActions>
    )
  }

  const extension = {
    request: { fetchList },
    events: {
      addTemplate,
    },
    // auth: authMap,
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      switchRender, // 开关渲染
      actionTool, // 操作按钮渲染
    },
  }

  return (
    <KeepAlive name={location.pathname} id={location.pathname}>
      <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
      <AddOrRenameModal
        isAdd={isAdd}
        listRef={listRef}
        clickInfo={clickInfo}
        open={addOrRenameModal}
        onCancel={() => setAddOrRenameModal(false)}
      />
    </KeepAlive>
  )
}

export default SignTemplate
